// 'use-strict'
import React, { Component } from 'react';
// import { Auth } from 'aws-amplify';
import {
  // Badge,
  // DropdownItem,
  // DropdownMenu,
  // DropdownToggle,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import PropTypes from 'prop-types';

import {
  // AppAsideToggler,
  // AppHeaderDropdown,
  AppNavbarBrand,
  // AppSidebarToggler,
} from '@coreui/react';
import logo from '../../assets/brand/logo.png';
import HeaderDropdown from './HeaderDropdown';

const propTypes = {
  children: PropTypes.node,
  onLogout: PropTypes.node,
};

const defaultProps = {
  children: null,
  onLogout: null,
};

class DefaultHeader extends Component {
  render() {
    // eslint-disable-next-line
        const {children, ...attributes} = this.props;

    return (
      <React.Fragment>
        {/* <AppSidebarToggler className="d-lg-none" display="md" mobile /> */}
        <AppNavbarBrand
          full={{
                        src: logo, width: 89, height: 40, alt: 'FLF Logo',
                    }}
        />
        {/* <AppSidebarToggler className="d-md-down-none" display="lg" /> */}

        <Nav className="d-md-down-none" navbar>
          {/* <NavItem className="px-3">
            <a href="/">View Reports</a>
          </NavItem>
          <NavItem className="px-3">
            <a href="/">Upload Report</a>
          </NavItem> */}
          {/* <NavItem className="px-3">
            <NavLink href="#">Settings</NavLink>
          </NavItem> */}
        </Nav>
        <Nav className="ml-auto" navbar>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-list" /></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-location-pin" /></NavLink>
          </NavItem>
          {/* <AppHeaderDropdown direction="down">
            <DropdownToggle nav className="mr-4">
              <strong>Account</strong>
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              <DropdownItem
                onClick={this.logout}
                header
                tag="div"
                className="text-center"
              >
                <strong>Log Out</strong>
              </DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown> */}
          <HeaderDropdown {...this.props} />
        </Nav>
        {/* <AppAsideToggler className="d-md-down-none" /> */}
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;



// WEBPACK FOOTER //
// ./src/components/MenuBar/DefaultHeader.js